<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <addHeader
          :title="$t('Add marketer')"
          :description="$t('From Here You Can Add A New Marketer')"
          v-if="$route.name == 'marketersCreate'"
        />
        <addHeader
          :title="$t('Edit Marketer')"
          :description="$t('From Here You Can Modify The Marketer Data')"
          v-if="$route.name == 'marketersEdit'"
        />
        <div class="mb-4 row">
          <dvider
            :title="$t('Basic information')"
            :description="$t('Basic Information For The Marketer')"
            noLine="true"
          />
          <formInput
            :title="$t('Marketers Name')"
            v-model="item.name"
            :hasErorr="errors.name"
            :error="$t('The Names Of The Marketer Cannot Be Empty')"
            maxlength="255"
          />
          <monyInput :title="$t('Balance')" v-model="item.balance" :hasErorr="false" />
          <!-- Divider -->
          <hr class="mt-5 mb-5 col-12" />
          <!-- Buttons -->
          <a
            @click="saveItem"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'marketersCreate' && !$parent.stopEdit"
          >
            {{ $t('Add marketer') }}
          </a>
          <a
            @click="saveItem"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'marketersEdit' && !$parent.stopEdit"
          >
            {{ $t('Edit marketer') }}
          </a>
          <loading v-if="$parent.stopEdit" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import formInput from '@/elements/add/form/formInput.vue'
import fileInput from '@/elements/add/form/fileInput.vue'
import connectionInput from '@/elements/add/form/connectionInput.vue'
import dvider from '@/elements/add/dvider.vue'
import addHeader from '@/elements/add/header.vue'
import loading from '@/elements/add/loading.vue'
import monyInput from '@/elements/add/form/monyInput.vue'

export default {
  data() {
    return {
      path: '/marketers',
      item: {},
      errors: {
        name: false
      }
    }
  },
  methods: {
    getItem() {
      axios.get(this.$linkGenerator(this.path + '/' + this.$route.params.id)).then((response) => {
        this.item = response.data
        this.$parent.stopEdit = false
      })
    },
    saveItem() {
      var error = 0
      if (typeof this.item.name === 'undefined' || this.item.name == '') {
        error = 1
        this.errors.name = true
      }
      if (error == 0) {
        if (this.$route.name == 'marketersCreate') {
          this.$parent.aletText = this.$t('Marketer Added Successfully')
          this.$parent.alertType = 'success'
          this.$addToLocalDatabase(this.item, this.path.substring(1))
          this.$router.go(-1)
        } else if (this.$route.name == 'marketersEdit') {
          this.item._method = 'PUT'
          this.$parent.stopEdit = true
          axios
            .post(this.$linkGenerator(this.path + '/' + this.item.id), this.item)
            .then((response) => {
              this.$parent.aletText = this.$t('The Marketer Has Been Successfully Modified')
              this.$parent.alertType = 'success'
              this.$router.go(-1)
              this.$parent.stopEdit = false
              return response
            })
        }
      } else {
        this.$parent.aletText = this.$t('please Make Sure Of The Input')
        this.$parent.alertType = 'danger'
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  mounted() {
    this.$updateDatabase(['marketers'])

    if (this.$route.name == 'marketersEdit') {
      this.$parent.stopEdit = true
      this.getItem()
    }
  },
  components: {
    formInput,
    fileInput,
    dvider,
    addHeader,
    connectionInput,
    loading,
    monyInput
  }
}
</script>
